export function getPreviousUrlAndCategory(category, categories, tier0Url: string, tier0PageType: string) {
  const { t1Idx, t2Idx } = category;
  let previousTierUrl;
  let previousTierPageType = tier0PageType;
  const categoryObj = {};

  if (category.tier3) {
    if (categories[t1Idx].tier2s[t2Idx].url) {
      const prevTierItem = categories[t1Idx].tier2s[t2Idx];
      previousTierUrl = prevTierItem.url;
      previousTierPageType = prevTierItem.pageType;
      categoryObj.tier3 = category.tier3;
    } else if (categories[t1Idx].url) {
      previousTierUrl = categories[t1Idx].url;
      previousTierPageType = categories[t1Idx].pageType;
      categoryObj.tier2 = category.tier2;
      categoryObj.tier3 = category.tier3;
    } else {
      previousTierUrl = tier0Url;
      categoryObj.tier1 = category.tier1;
      categoryObj.tier2 = category.tier2;
      categoryObj.tier3 = category.tier3;
    }
  } else if (category.tier2) {
    if (categories[t1Idx].url) {
      previousTierUrl = categories[t1Idx].url;
      previousTierPageType = categories[t1Idx].pageType;
      categoryObj.tier2 = category.tier2;
    } else {
      previousTierUrl = tier0Url;
      categoryObj.tier1 = category.tier1;
      categoryObj.tier2 = category.tier2;
    }
  } else if (category.tier1) {
    if (!categories[t1Idx].url) {
      previousTierUrl = tier0Url;
      categoryObj.tier1 = category.tier1;
    }
  } else {
    previousTierUrl = tier0Url;
    categoryObj.tier0 = category.tier0;
  }

  return { previousTierUrl, categoryObj, previousTierPageType };
}
